module.exports = __webpack_public_path__ + "img/index-manual-step-2@3x.bb77b669.png";